import React from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { icon } from "@/app/style/icons";

interface AttachmentPreviewProps {
    fileName: string;
    size: number;
    tokens: number;
    pages: number;
    onRemove?: () => void;
    disabled?: boolean;
    variant?: "light" | "dark";
    mode?: "input" | "message";
}

const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({ 
    fileName, 
    size, 
    tokens, 
    pages, 
    onRemove, 
    disabled = false,
    variant = "light",
    mode = "input"
}) => {
    const theme = useTheme();

    const formatFileSize = (bytes: number): string => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
    };

    const tokensToPages = (tokens: number): number => {
        // 800 tokens per page (matching backend calculation)
        return Math.ceil(tokens / 800);
    };


    const backgroundColor = variant === "light" 
        ? theme.palette.action.hover 
        : "rgba(255, 255, 255, 0.1)";

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 1,
                backgroundColor,
                borderRadius: 1,
                border: `1px solid ${theme.palette.divider}`,
            }}
        >
            <icon.attachFile sx={{ color: "semantic.icon.functional", fontSize: 18 }} />
            <Box sx={{ flexGrow: 1 }}>
                <Typography fontSize={13} fontWeight={500}>
                    {fileName}
                </Typography>
                {mode === "input" && (
                    <Typography fontSize={11} color="text.secondary">
                        {formatFileSize(size)} • Kosten: {tokensToPages(tokens)} Seiten
                    </Typography>
                )}
            </Box>
            {onRemove && (
                <IconButton size="small" onClick={onRemove} disabled={disabled}>
                    <icon.close sx={{ fontSize: 18 }} />
                </IconButton>
            )}
        </Box>
    );
};

export default AttachmentPreview;

